/**
 * HintCard — right-rail blue card that shows phase-specific guidance.
 *
 * Uses `--cn-yinsh-phase-*` tokens for the calm sky-blue look from the spec.
 * Multiplayer also reuses this card to render "Waiting for opponent…" when
 * it's not the local player's turn — the wireframe banner has been replaced
 * by this card slot.
 */

interface HintCardProps {
  readonly label: string;
  readonly text: string;
}

export function HintCard({ label, text }: HintCardProps) {
  return (
    <div
      data-testid="hint-card"
      style={{
        background: "var(--cn-yinsh-phase-bg)",
        border: "1px solid var(--cn-yinsh-phase-border)",
        borderRadius: "var(--cn-radius-lg)",
        padding: 16,
      }}
    >
      <div
        style={{
          fontSize: "var(--cn-font-size-xs, 12px)",
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          color: "var(--cn-yinsh-phase-text)",
          marginBottom: 4,
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontSize: "var(--cn-font-size-base, 14px)",
          color: "var(--cn-text-primary)",
          lineHeight: 1.5,
        }}
      >
        {text}
      </div>
    </div>
  );
}
